import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cloud-storage.svg
 */
const IconCloudStorage: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 3H8v3h11V3zM8 2a1 1 0 00-1 1v3a1 1 0 001 1h11a1 1 0 001-1V3a1 1 0 00-1-1H8zM19 9H8v3h11V9zM8 8a1 1 0 00-1 1v3a1 1 0 001 1h11a1 1 0 001-1V9a1 1 0 00-1-1H8zM19 15H8v3h11v-3zM8 14a1 1 0 00-1 1v3a1 1 0 001 1h11a1 1 0 001-1v-3a1 1 0 00-1-1H8z"
      fill="currentColor"
    />
    <path
      d="M14 4h1v1h-1V4zM14 10.5h1v1h-1v-1zM14 16h1v1h-1v-1zM16 4h2v1h-2V4zM16 10.5h2v1h-2v-1zM16 16h2v1h-2v-1zM5 6a1 1 0 011-1h1v1H5zM6 17h1v1H6v-1zM5.378 20H19.87v1H5.38v-1zM6 11h1v1H6v-1z"
      fill="currentColor"
    />
    <path d="M5 6h1v14.464H5V6z" fill="currentColor" />
    <path d="M7 20.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" fill="currentColor" />
  </svg>
);

export default IconCloudStorage;
